import OrderOverview from './overview'
module.exports = {
  OrderOverview
}



// WEBPACK FOOTER //
// ./src/projects/access-gui/views/orders/index.js